export default __webpack_public_path__ + "static/artifakt-element-regular-40f5773f4440e44dc44e88442578618e.eot";